import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Col, Label, Row } from 'reactstrap';

import styles from './style.module.scss';

// import { ContributionForProductData } from './ChartData/ContributionForProduct';
import { IContributionForProductChart } from '../../../interfaces/charts.interface';
import { IPhasingRow } from '../../../interfaces/rolling-plan-phasing.interface';

import NoDataFound from '../../../components/Common/no-data-found/no-data-found';
import PieChart from '../../../components/Common/Charts/PieChart';

import { TwoDecimalPlace } from '../../../helpers/Helpers';

interface OwnProps {
}

interface StateProps {
  phasingData: IPhasingRow[];
  phasingType: string;
}

interface DispatchProps {
}

type Props = StateProps & DispatchProps & OwnProps;

interface State {
  originalDataSource: IContributionForProductChart[];
  dataSource: IContributionForProductChart[];
}

class ContributionForProduct extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      originalDataSource: [],
      dataSource: []
    };
  }

  componentDidMount(): void {
    this.dataInit();
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if (this.props.phasingType !== prevProps.phasingType) {
      this.dataInit();
    }
  }

  dataInit(): void {
    const opacityMax = 1;
    const opacityMin = 0.2;
    const length = this.props.phasingData.length;
    const equalPoint = (opacityMax - opacityMin) / (length - 1);

    const dataSource: IContributionForProductChart[] =
      this.props.phasingData.map((data, groupIdx: number) => {
        return {
          name: data.name,
          value: this.props.phasingType === 'UNITS' ? Math.round(data.value) : TwoDecimalPlace(data.value),
          pctValue: data.pctValue,
          color: `rgba(39, 20, 101, ${opacityMax - (equalPoint * groupIdx)})`
        };
      });

    this.setState({
      dataSource,
      originalDataSource: dataSource
    });
  }

  /*onUpdateGroup(groupIdx: number): void {
    this.state.originalDataSource[groupIdx].checked = !this.state.originalDataSource[groupIdx].checked;

    const filteredDataSource = this.state.originalDataSource.filter((group) => group.checked);
    this.setState({dataSource: filteredDataSource});
  }

  onUpdateSubgroup(subgroupIdx: number): void {
    this.state.originalDataSource.forEach((subgroup) => {
      subgroup.children[subgroupIdx].checked = !subgroup.children[subgroupIdx].checked;
    });
    /!*const groupIdx = this.state.originalDataSource.findIndex((group) => group.name === this.state.selectedGroup);
    this.state.originalDataSource[groupIdx].children[index].checked = !this.state.originalDataSource[groupIdx].children[index].checked;

    const filteredDataSource = this.state.originalDataSource
      .filter((group) => group.name === this.state.selectedGroup && group.children
        .some((subgroup) => subgroup.checked))
      .map((group) => Object.assign({}, group, {
        children: group.children
          .filter((subgroup) => subgroup.checked)
      }));

    this.setState({
      dataSource: filteredDataSource,
      colorList: filteredDataSource[0].children.map((value) => value.color)
    });*!/
  }*/

  render(): React.ReactNode {
    if (this.state.dataSource.length === 0) {
      return (
        <NoDataFound/>
      );
    }

    return (
      <React.Fragment>
        <Row style={{marginTop: '18px'}}>
          <Col md={9} className="text-center">

            {/*<Row>
              <Col md={{
                offset: 8,
                size: 4
              }}>
                <div className="d-flex">
                  {
                    this.state.originalDataSource.map((group, idx: number) => (
                      <div
                        key={idx}
                        className="d-flex align-items-center"
                      >
                        <Input
                          id={group.name}
                          type="checkbox"
                          checked={group.checked}
                          onChange={() => this.onUpdateGroup(idx)}
                          className="me-1"
                        />
                        <Label for={group.name} className="measure-group">{group.name}</Label>
                      </div>
                    ))
                  }
                </div>
              </Col>
            </Row>*/}

            <div className="d-flex justify-content-center">
              <PieChart
                dataSource={this.state.dataSource}
                component={'ContributionForProduct'}
              />
            </div>

          </Col>

          <Col md={3} className="align-self-end">

            <div className={styles['legend-section']}>
              <p className={styles['line-chart-legend-header']}>Products</p>
              {
                this.state.originalDataSource.map((group, groupIdx: number) => (
                  <React.Fragment
                    key={groupIdx}
                  >
                    <div
                      className="d-flex align-items-center my-2"
                    >
                      {/*<Input
                          id={group.name}
                          type="checkbox"
                          checked={group.checked}
                          onChange={() => this.onUpdateSubgroup(groupIdx)}
                        />*/}

                      <div
                        className={styles['legend-color-box']}
                        style={{backgroundColor: group.color}}
                      />

                      <Label
                        for={group.name}
                        className={styles['measure-group']}
                      >
                        {group.name}
                      </Label>
                    </div>
                  </React.Fragment>
                ))
              }
            </div>

          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any): StateProps => {
  return {
    ...state.PhasingDataSource,
    phasingType: state.PhasingType.phasingType
  };
};

export default connect<StateProps, DispatchProps, OwnProps>
(mapStateToProps, {})(withRouter(ContributionForProduct));
